module.exports = __webpack_public_path__ + "static/media/C3.c7f87dc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C3.mp4
// module id = pU+m
// module chunks = 8